import configureStore from "./index";

const { store } = configureStore();

// eslint-disable-next-line import/prefer-default-export
export { store };
